import { render, staticRenderFns } from "./TotalRecharge.vue?vue&type=template&id=120678ec&scoped=true&"
import script from "./TotalRecharge.vue?vue&type=script&lang=js&"
export * from "./TotalRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120678ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120678ec')) {
      api.createRecord('120678ec', component.options)
    } else {
      api.reload('120678ec', component.options)
    }
    module.hot.accept("./TotalRecharge.vue?vue&type=template&id=120678ec&scoped=true&", function () {
      api.rerender('120678ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/payAnalysis/components/TotalRecharge.vue"
export default component.exports